import React, { useState } from "react";
import {
	Container,
	Title,
	TabsContainer,
	CardsContainer,
	TabTitle,
	TabTitleContainer,
	Card,
	ImageContainer,
	CardTitle,
	ExpandableCards,
	ExpandableTitle,
	FlexCardsContainer,
	ExpandContainer,
	Arrow,
} from "./styles";
import { CtaButton } from "../../Elements";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";

const CompareCareerTracks = ({ title, tabs, darkBg = false }) => {
	//Used in desktop View
	const [currentTab, setCurrentTab] = useState(0);

	//Used for mobile view as multiple tabs could be active
	//Default set Active tab in mobile to 1st Option
	const [activeTabs, setActiveTabs] = useState({ 0: true });

	const handleTabChange = (index) => {
		setCurrentTab(index);
	};
	return (
		<Container>
			<Title darkBg>{title}</Title>
			<TabsContainer>
				<TabTitleContainer>
					{tabs.map((t, i) => {
						return (
							<TabTitle
								darkBg
								isActive={currentTab === i}
								onClick={() => handleTabChange(i)}
							>
								{t.name}
							</TabTitle>
						);
					})}
				</TabTitleContainer>
				<CardsContainer>
					{tabs.map((t, ti) => {
						return (
							<>
								<ExpandContainer
									onClick={() =>
										setActiveTabs({ ...activeTabs, [ti]: !activeTabs[ti] })
									}
								>
									<ExpandableTitle>{t.name}</ExpandableTitle>
									<Arrow isActive={activeTabs[ti]}>
										<CloudinaryImage
											url="https://res.cloudinary.com/springboard-images/image/upload/v1636294906/arrow.png"
											lazyload
										/>
									</Arrow>
								</ExpandContainer>
								<ExpandableCards
									isActive={activeTabs[ti]}
									currentTab={currentTab == ti}
								>
									<FlexCardsContainer>
										{t.cards.map((c) => {
											let segmentEventData = null;

											if (c.courseId) {
												segmentEventData = {
													eventName: "Clicked Learn More About Career Tracks",
													eventProperties: {
														course_id: c.courseId,
													},
												};
											}

											return (
												<Card>
													<ImageContainer>
														<CloudinaryImage
															url={c?.image?.image}
															lazyload
															sizes={{
																"322px": {
																	width: 95,
																},
																default: {
																	width: 95,
																},
															}}
														/>
													</ImageContainer>
													<CardTitle>{c.title}</CardTitle>
													<div className="description">{c.description}</div>
													<CtaButton
														cta={c.cta}
														segmentEventData={segmentEventData}
													/>
												</Card>
											);
										})}
									</FlexCardsContainer>
								</ExpandableCards>
							</>
						);
					})}
				</CardsContainer>
			</TabsContainer>
		</Container>
	);
};

export default CompareCareerTracks;
